<template>
    <v-container fluid fill-height align-center justify-center>
      <v-flex xs12 sm6 md3>
        <v-card class="elevation-6" v-if="!isForgotPasswordFormVisible">
          <v-toolbar dark class="elevation-0" color="primary" >
            <v-toolbar-title>Login</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <ContentField
              name="userNameOrEmail"
              label="User name or Email"
              type="text"
              v-model="userData.userNameOrEmail"
              :error="$v.userData.userNameOrEmail"
            />
            <ContentField
              name="password"
              label="Password"
              type="password"
              v-model="userData.password"
              :error="$v.userData.password"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="displayForgotPasswordForm">
              Forgot password
            </v-btn>
            <v-btn color="primary" @click="sendLoginRequest">
              Login
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card class="elevation-6" v-else>
          <v-toolbar dark class="elevation-0" color="primary" >
            <v-toolbar-title>Enter your email</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-title>
            <h5>*we will send you a link to update your password</h5>
          </v-card-title>
          <v-card-text>
            <ContentField
              name="email"
              label="User email"
              type="text"
              v-model="resetPasswordData.userEmail"
              :error="$v.resetPasswordData.userEmail"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="returnToLoginForm">
              <v-icon dark>arrow_back_ios</v-icon> Return to login
            </v-btn>
            <v-btn
              :disabled="$v.resetPasswordData.userEmail.$invalid"
              color="primary"
              @click="sendEmailToResetPassword">
              Submit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import ContentField from '@/components/shared/ContentField'
import { required, email } from 'vuelidate/lib/validators'

  export default {
    name: 'LoginPage',
    components: { ContentField },
    data () {
      return {
        userData: {
          userNameOrEmail: '',
          password: ''
        },
        resetPasswordData: {
          userEmail: ''
        },
        isForgotPasswordFormVisible: false
      }
    },
    validations: {
      userData: {
        userNameOrEmail: {
          required
        },
        password: {
          required
        }
      },
      resetPasswordData: {
        userEmail: {
          required,
          email
        }
      }
    },
    methods: {
      ...mapActions(['authenticateUser', 'requestPasswordReset']),
      async sendLoginRequest() {
        this.$v.userData.$touch()
        if (this.$v.userData.$invalid) return
        await this.authenticateUser(this.userData)
      },
      loginAction (e) {
        if (e.keyCode === 13) {
          this.sendLoginRequest()
        }
      },
      displayForgotPasswordForm () {
        this.isForgotPasswordFormVisible = true
      },
      returnToLoginForm () {
        this.isForgotPasswordFormVisible = false
      },
      async sendEmailToResetPassword () {
        try {
          this.$v.resetPasswordData.$touch()
          if (this.$v.resetPasswordData.$invalid) return

          this.requestPasswordReset({
            email: this.resetPasswordData.userEmail
          })
          this.$v.resetPasswordData.$reset()
          this.resetPasswordData.userEmail = ''
        } catch (err) {
          console.error(err)
        }
      }
    },
    computed: {
      ...mapGetters(['isLoggedIn']),
    },
    mounted() {
      window.addEventListener('keyup', this.loginAction)
    },
    beforeDestroy () {
      window.removeEventListener('keyup', this.loginAction)
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/pages/Login/index.vue